/* eslint-disable */
import {processar, processaReport} from '../../../../services/GenericAPI'
import {Filtro} from "../../../../models/filtro/filtro";
import {BaseSCH} from "../../../../search/BaseSCH";

const url = '/resumo_gerencial';

const state = {
  all: [],
  filtro: new Filtro(),
  pdf: ''
};

const getters = {
  pegaPdf: (state) => {
    return state.pdf
  },
  pegaFiltro: (state) => {
    return state.filtro
  },
};

const actions = {
  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', BaseSCH(perPage))
  },
  async processarRelacaoNota({commit}, {resumo_gerencial, acao}) {
    try {
      let res = await processar(url, resumo_gerencial, acao);
      this.dispatch('geral/setMsgSuccess', res.data.message)
    } catch (error) {
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  async GerarRelatorioPdf({commit}, {filtro, onSucesso, onErro}) {
    try {
      const retorno = (await processaReport(url + '/pdf', filtro));
      commit('SET_PDF', retorno);
      onSucesso(retorno)
    } catch (error) {
      console.log('ERRO: ', error);
      onErro()
    }
  },
};

const mutations = {
  SET_PDF(state, pdf) {
    state.pdf = pdf
  },
  SET_FILTRO(state, pdf) {
    state.filtro = pdf
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
